import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import Spinner from './common/Spinner';
import AlertMessage from './common/AlertMessage';

import IdAndPhoneStep from './steps/01_IdAndPhoneStep';
import SmsCodeStep from './steps/02_SmsCodeStep';
import LoanOptionsStep from './steps/03_LoanOptionsStep';
import IdDataStep from './steps/04_IdDataStep';
import AddressStep from './steps/05_AddressStep';
import PhotoUploadStep from './steps/06_PhotoUploadStep';
import IdVerificationNoticeStep from './steps/07_IdVerificationNoticeStep';
import IdFilesUploadStep from './steps/08_IdFilesUploadStep';
import FinalStep from './steps/09_FinalStep';
import ErrorStep from './steps/99_ErrorStep';

import { formVariants, formSteps } from '../constants/form';
import { useDataProviderState } from '../providers/DataProvider';


function CurrentForm() {
    const { initialData, showErrorPage, currentFormVariant, currentFormStepIndex } = useDataProviderState();

    if (showErrorPage) return (<ErrorStep />);

    if (!initialData) return (<Spinner loading />);

    switch (formVariants[currentFormVariant][currentFormStepIndex]) {
        case formSteps.ID_PHONE:
            return <IdAndPhoneStep />
        case formSteps.SMS_CODE:
            return <SmsCodeStep />
        case formSteps.LOAN_OPTIONS:
            return <><LoanOptionsStep /></>
        case formSteps.ID_DATA:
            return <><IdDataStep /></>
        case formSteps.ADDRESS:
            return <><AddressStep /></>
        case formSteps.ID_VERIFICATION_NOTICE:
            return <><IdVerificationNoticeStep /></>
        case formSteps.PHOTO_UPLOAD:
            return <><PhotoUploadStep /></>
        case formSteps.ID_FILES_UPLOAD:
            return <><IdFilesUploadStep /></>
        case formSteps.FINAL:
            return <><FinalStep /></>
        default:
            return null
    }
}

export default function Content() {

    return (
        <Box as="main" sx={{
            top: 0,
            width: '100vw',
            minHeight: '100vh',
            backgroundColor: 'var(--background)',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: ' var(--header-height)'
        }}>
            <Container
                component="section"
                maxWidth="md"
                sx={{ py: 5, background: '#f5f5f5', boxShadow: '2px 0 15px -4px rgb(211 211 211 / 80%), -2px 0 8px -4px rgb(194 194 194 / 80%)' }}>

                <AlertMessage />

                <CurrentForm />
            </Container>

        </Box>
    )
}
